module.exports = __webpack_public_path__ + "static/media/cancel_1.20378fd9.png";